export function getZoneKey(page: string): string {
  return `${page}-completed`;
}

export function markZoneAsCompleted(page: string): void {
  localStorage.setItem(getZoneKey(page), 'true');
}

export function isZoneCompleted(page: string): boolean {
  return localStorage.getItem(getZoneKey(page)) === 'true';
}

export function guardPageAccess(page: string): void {
  const flow = ['intro', 'shadowzone', 'neozone', 'openzone', 'herozone'];
  const currentIndex = flow.indexOf(page);

  if (currentIndex === -1) return;

  for (let i = 0; i < currentIndex; i++) {
    const previousPage = flow[i];
    const key = getZoneKey(previousPage);

    if (localStorage.getItem(key) !== 'true') {
      window.location.href = './index.html';
      return;
    }
  }
}